export default "__VITE_ASSET__DZytWXOH__"